/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Tue May 23 2023
 **/

import styled from "@emotion/styled";

import { Column, Row, Typography, TypographyCSS } from "@/frameworks/designStuff/components";
import { Drawer } from "@/frameworks/designStuff/compounds";

export const ChatSearchLayout = styled(Drawer.Wrap)`
	width: 100%;
	height: 100%;
	background-color: ${({ theme }) => theme.colors.neutral_00_80};
	filter: drop-shadow(12px 0px 20px rgba(0, 0, 0, 0.16));
	backdrop-filter: blur(14px);
`;

export const ChatSearchHeader = styled(Drawer.Header)`
	padding: 10px 20px;
	width: 100%;
	#keyword {
		${TypographyCSS("Title1_B")}
	}
`;

export const SearchedConversationItem = styled(Row)`
	width: 100%;
	padding: 8px 4px;
	border-radius: 16px;
	&:hover {
		background-color: ${({ theme }) => theme.colors.secondary_80_8};
	}
`;

export const ContentWrapper = styled(Column)`
	width: -webkit-fill-available;
	pointer-events: none;
`;

export const EmphasisSearchText = styled(Typography)`
	width: 100%;
	#search-text {
		background-color: ${({ theme }) => theme.colors.accent_10_100};
	}
`;

export const Body = styled(Drawer.Body)`
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	width: 100%;
	height: 100%;
	overflow: auto;
`;
